import classNames from 'classnames';

import ToolRating from '../ToolRating';

import useStyles from './styles';
import IReviewSnippet from './types';

function ReviewSnippet({
  children,
  ratingCount,
  ratingValue,
  title,
  subtitle,
  customClass,
  ratingClass,
}: IReviewSnippet) {
  const classes = useStyles();

  return (
    <section className={classNames(classes.root, customClass)}>
      <ToolRating
        className={ratingClass}
        review={ratingValue}
        reviewsNumber={ratingCount}
        title={title}
      />
      {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
      {children}
    </section>
  );
}

export default ReviewSnippet;
